import Link from 'next/link'
import { ReactElement } from 'react'
import styled from 'styled-components'

const StylesAnchor = styled.a`
  display: flex;
  align-items: center;
  cursor: pointer;
`

const StyledArrowImg = styled.img`
  height: 20px;
  margin-left: 16px;
`

type LinkWithArrowProps = {
  children?: ReactElement<any> | string
  dataTestId?: string
  href: string
  id?: string
}

export const LinkWithArrow = ({ children, dataTestId, href, id }: LinkWithArrowProps) => {
  return (
    <Link href={href} passHref legacyBehavior>
      <StylesAnchor id={id} data-testid={dataTestId}>
        {children}
        <StyledArrowImg src="/assets/img/icons/link-arrow-blue.svg" alt="" />
      </StylesAnchor>
    </Link>
  )
}
